import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import theme from './config/theme';
import Home from './pages/Home';
import HeroHome from './pages/HeroHome';
import Exporter from './pages/Exporter';
import data from './data/data.json';

function App() {
  return (
    <React.Suspense fallback={"loading..."}>
		<ThemeProvider theme={theme}>
			<Router>
				<Routes>
					<Route path="/" exact element={<HeroHome />} />
					<Route path="/basic" exact element={<Home />} />
					<Route path="/search/:term" element={<HeroHome />} />
					<Route path="/export" element={<Exporter data={ data.codes } />} />
				</Routes>
			</Router>
		</ThemeProvider>
	</React.Suspense>
  );
}

export default App;
